import { Anchor, Group, type GroupProps, Text } from "@mantine/core"
import { useTranslation } from "react-i18next"

export function Footer(props: GroupProps) {
  const { t } = useTranslation()
  return (
    <Group px="md" {...props} justify="center" gap="md" c="dimmed">
      <Text size="sm">v. {process.env.VERSION}</Text>
      <Text span>·</Text>
      <Anchor href="/legal/privacy" size="sm" target="_blank" rel="noopener noreferrer">
        {t("Privacy Policy")}
      </Anchor>
      <Text span>·</Text>
      <Anchor href="/legal/terms" size="sm" target="_blank" rel="noopener noreferrer">
        {t("Terms of Service")}
      </Anchor>
      <Text span>·</Text>
      <Anchor href="/legal/contacts" size="sm" target="_blank" rel="noopener noreferrer">
        {t("Contacts")}
      </Anchor>
    </Group>
  )
}
